import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Panel } from '../../../../common/panel'
import { panelTypes } from '../../../../common/panel/constants'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { IndustryScaleTable } from './IndustryScaleTable'
import { resetStore, selectIds } from './store/slice'
import { downloadIndustryScale, getIndustryScaleTable } from './store/thunk'

export const IndustryScale = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { currency, unitName, multiplier } = useFormatCurrency(
    SCREEN.INDUSTRY_OVERVIEW,
  )

  const ids = useSelector(selectIds)
  const locale = useSelector((state) => state.i18n.locale)
  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })

  useEffect(() => {
    dispatch(
      getIndustryScaleTable({
        OrganizationId: organizationId,
      }),
    )
  }, [locale, organizationId])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  return (
    <Panel
      isI18n
      height={332}
      label="industryOverview.industryScale.INDUSTRY_SCALE"
      type={panelTypes.HALF_SIZE}
      downloadCsv={{
        disabled: !ids.length,
        downloadFunc: () =>
          downloadIndustryScale({
            organizationId,
            currency,
            currencyUnit: {
              multiplier,
              value: unitName,
            },
          }),
      }}
    >
      <IndustryScaleTable />
    </Panel>
  )
}
